import Info from "./Info";
import Panel from "./Panel";
import TableTitle from "./TableTitle";
import Title from "./Title";

const UserGuide = { Info, Panel, TableTitle, Title };

export default UserGuide;
